import { Link, useParams } from "react-router-dom";
import { getSpecials, getSpecialById, getDramasByIds } from "@/utils/content";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import DramaCard from "@/components/feature/DramaCard";

export default function Special() {
  const { id } = useParams();
  const special = id ? getSpecialById(id) : undefined;
  const all = getSpecials();

  if (id && !special) {
    return (
      <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center px-4 py-24 md:px-6">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-300">
          <i className="ri-bookmark-line text-3xl"></i>
        </span>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950">未找到该专题</h1>
        <Link
          to="/special"
          className="mt-5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          返回专题列表
        </Link>
      </div>
    );
  }

  if (special) {
    const items = getDramasByIds(special.dramaIds);
    const related = getDramasByIds([]);
    const relatedSpecials = all.filter((item) => special.relatedIds.includes(item.id));
    void related;

    return (
      <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-6 md:py-8">
        <title>{`${special.title} - 影视推荐专题 - 善良的嫂子影视站`}</title>
        <meta name="description" content={`${special.subtitle}。${special.intro}`} />
        <meta name="keywords" content={`${special.title},${special.theme},影视专题,影视推荐`} />

        <Breadcrumbs items={[{ label: "专题", to: "/special" }, { label: special.title }]} />

        <section className="mt-4 overflow-hidden rounded-lg bg-secondary-950">
          <div className="relative h-48 w-full md:h-64">
            <img
              src={special.cover}
              alt={`${special.title} 专题主图`}
              title={`${special.title} 影视推荐`}
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-black/20"></div>
            <div className="absolute bottom-0 left-0 p-4 md:p-6">
              <span className="rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-accent-950">
                {special.theme}合集
              </span>
              <h1 className="mt-2 font-heading text-2xl font-bold text-white md:text-3xl">{special.title}</h1>
              <p className="mt-1 text-sm text-white/80">{special.subtitle}</p>
            </div>
          </div>
          <div className="p-4 md:p-6">
            <p className="text-sm leading-relaxed text-background-200 md:text-base">{special.intro}</p>
            <div className="mt-4 rounded-md bg-primary-950/60 p-4">
              <h2 className="flex items-center gap-2 font-heading text-sm font-semibold text-accent-300">
                <span className="flex h-4 w-4 items-center justify-center"><i className="ri-thumb-up-line"></i></span>
                推荐理由
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-background-200">{special.reason}</p>
            </div>
          </div>
        </section>

        <section className="mt-8">
          <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">专题收录作品</h2>
          <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-5">
            {items.map((drama) => (
              <DramaCard key={drama.id} drama={drama} />
            ))}
          </div>
        </section>

        {relatedSpecials.length > 0 && (
          <section className="mt-10">
            <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">相关专题</h2>
            <div className="mt-4 flex flex-wrap gap-3">
              {relatedSpecials.map((item) => (
                <Link
                  key={item.id}
                  to={`/special/${item.id}`}
                  className="flex items-center gap-2 rounded-full bg-background-100 px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
                >
                  <span className="flex h-4 w-4 items-center justify-center"><i className="ri-bookmark-3-line"></i></span>
                  {item.title}
                </Link>
              ))}
            </div>
          </section>
        )}
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-6 md:py-8">
      <title>影视推荐专题 - 善良的嫂子影视站</title>
      <meta name="description" content="善良的嫂子影视站精选影视专题合集，按主题为你推荐优质影视作品，涵盖热播剧、家庭情感、悬疑与年代经典。" />
      <meta name="keywords" content="影视专题,影视推荐,主题合集,善良的嫂子" />

      <Breadcrumbs items={[{ label: "专题" }]} />

      <div className="mt-4 border-b border-background-200 pb-5">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">相关推荐专题</h1>
        <p className="mt-2 max-w-2xl text-sm text-foreground-500">
          按主题精选的影视合集，每个专题都有明确的推荐理由，帮你快速找到感兴趣的内容。
        </p>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-5 lg:grid-cols-2">
        {all.map((item) => {
          const covers = getDramasByIds(item.dramaIds).slice(0, 3);
          return (
            <Link
              key={item.id}
              to={`/special/${item.id}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="h-44 w-full overflow-hidden bg-background-200 md:h-52">
                <img
                  src={item.cover}
                  alt={`${item.title} 专题主图`}
                  title={`${item.title} 影视推荐专题`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <span className="w-fit rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800">
                  {item.theme}合集
                </span>
                <h2 className="mt-2 font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600">
                  {item.title}
                </h2>
                <p className="mt-1 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.intro}</p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {covers.map((drama) => (
                    <span key={drama.id} className="rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">
                      {drama.title}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}